$(document).ready(() => {
	const container = $('.container-main');
	const buttons = container.find('.open-tab');
	const isolatedStyle = container.find('.button-circle-isolated');
	const tabs = container.find('.tab');
	const prev = container.find('.pagination .prev');
	const next = container.find('.pagination .next');

	let activeTab = 1;

	const setIsolatedStyle = () => {
		if (activeTab) {
			const buttonCircle = container.find(`.button-circle[data-tab=${activeTab}]`);
			const top = buttonCircle.css('top');
			const left = buttonCircle.css('left');

			if (top && left) {
				isolatedStyle.css({
					top,
					left,
					display: 'flex'
				})
			}
		}
	};

	if ($(window).width() > 960) {
		const button = container.find('.open-tab[data-tab=1]');

		button.addClass('active');
		container.find('.tab[data-tab=1]').show(('normal'));

		setIsolatedStyle();
	}

	$(window).on('resize', () => {
		if ($(window).width() > 960) {
			container.removeClass('active');
		} else {
			if (activeTab) {
				container.addClass('active');
			}
		}

		setIsolatedStyle();
	});

	buttons.on('click', (e) => {
		const mobile = $(window).width() <= 960;

		setTimeout(() => {
			const self = $(e.currentTarget);

			activeTab = Number(self.attr('data-tab'));

			const button = container.find(`.open-tab[data-tab=${activeTab}]`);

			buttons.removeClass('active');
			button.addClass('active');

			tabs.hide(('normal'));
			container.find(`.tab[data-tab=${activeTab}]`).show(('normal'));

			setIsolatedStyle();

			if (activeTab === 1) {
				next.removeClass('disabled');
				prev.addClass('disabled');
			} else if (activeTab === 11) {
				prev.removeClass('disabled');
				next.addClass('disabled');
			} else {
				prev.removeClass('disabled');
				next.removeClass('disabled');
			}
		}, container.hasClass('active') || !mobile ? 0 : 300);

		if (mobile) {
			container.addClass('active');
		}
	});

	prev.on('click', () => {
		if (!prev.hasClass('disabled')) {
			if (activeTab) {
				activeTab = Number(activeTab - 1);

				buttons.removeClass('active');
				tabs.hide(('normal'));

				container.find(`.tab[data-tab=${activeTab}]`).show(('normal'));
				container.find(`.open-tab[data-tab=${activeTab}]`).addClass('active');
			}

			if (activeTab === 1) {
				prev.addClass('disabled');
				next.removeClass('disabled');
			} else {
				prev.removeClass('disabled');
				next.removeClass('disabled');
			}

			setIsolatedStyle();
		}
	});

	next.on('click', () => {
		if (!next.hasClass('disabled')) {

			if (activeTab) {
				activeTab = Number(activeTab + 1);

				buttons.removeClass('active');
				tabs.hide(('normal'));

				container.find(`.tab[data-tab=${activeTab}]`).show(('normal'));
				container.find(`.open-tab[data-tab=${activeTab}]`).addClass('active');
			}

			if (activeTab === 11) {
				next.addClass('disabled');
				prev.removeClass('disabled');
			} else {
				prev.removeClass('disabled');
				next.removeClass('disabled');
			}

			setIsolatedStyle();
		}
	})
});
